export default "__VITE_ASSET__CbURBsU0__"